
import { useExpertApplicationsData } from "./expert-applications/useExpertApplicationsData";
import { useExpertApplicationsFiltering } from "./expert-applications/useExpertApplicationsFiltering";
import { useExpertApplicationsState } from "./expert-applications/useExpertApplicationsState";
import { useExpertApplicationsActions } from "./expert-applications/useExpertApplicationsActions";
import { ExpertApplication } from "@/types/admin";

export function useExpertApplicationsLogic() {
  const {
    applications,
    publishedExperts,
    isLoading,
    handleManualRefresh,
    handleDataRefresh,
    fetchPublishedExperts
  } = useExpertApplicationsData();

  const {
    selectedApplication,
    adminNotes,
    activeTab,
    setAdminNotes,
    setActiveTab,
    handleSelectApplication,
    onCloseDetails
  } = useExpertApplicationsState();

  const { getFilteredApplications, getStatusCount } = useExpertApplicationsFiltering(
    applications,
    publishedExperts
  );

  const { onStatusUpdate, onDeleteApplication } = useExpertApplicationsActions(
    applications,
    isLoading,
    isLoading,
    handleDataRefresh
  );

  const handleStatusUpdate = (applicationId: string, status: 'approved' | 'rejected') => {
    return onStatusUpdate(applicationId, status, adminNotes, selectedApplication, setActiveTab);
  };

  return {
    // State
    applications,
    publishedExperts,
    selectedApplication,
    adminNotes,
    activeTab,
    isLoading,
    
    // Actions
    setAdminNotes,
    setActiveTab,
    getFilteredApplications: () => getFilteredApplications(activeTab),
    getStatusCount,
    onStatusUpdate: handleStatusUpdate,
    onDeleteApplication,
    onCloseDetails,
    handleSelectApplication,
    handleManualRefresh
  };
}
